import { searchState } from '../state/search'
import {
  pageState,
  pageErrorState,
  deliverabilityIndexState
} from '../state/page'
import { resultsState, selectionState } from '../state/results'
import { fetchMessages, getDeliverabilityIndex } from '../actions/actions'

import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { modalOpportunityState } from 'Components/ModalOpportunity/recoil/state/modal'

export const resetStateCallback = ({ reset }) => async () => {
  reset(deliverabilityIndexState)
  reset(pageState)
  reset(modalOpportunityState)
}

async function doFetch(set, searchParams) {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))
  set(searchState, searchParams)
  try {
    const results = await fetchMessages(searchParams)
    set(resultsState, {
      items: results.Items,
      totalItems: results.TotalItems,
      searchParams
    })
    // set(selectionState, [])
  } catch (error) {
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}
export const resetSelectionCallback = ({ reset }) => async () => {
  reset(selectionState)
}
export const searchMessagesCallback = ({ snapshot, set }) => async params => {
  const prevSearchState = await snapshot.getPromise(searchState)

  const searchParams = {
    ...prevSearchState,
    ...params
  }

  await doFetch(set, searchParams)
}

export const resetSearchCallback = ({ reset, set }) => async () => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  reset(searchState)

  try {
    const results = await fetchMessages()
    set(resultsState, {
      items: results.Items,
      totalItems: results.TotalItems,
      searchParams: {}
    })
    set(selectionState, [])
  } catch (error) {
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}

export const pageChangeCallback = ({ snapshot, set }) => async pageNumber => {
  const searchForm = await snapshot.getPromise(searchState)
  const newSearchForm = { ...searchForm, pageNumber }

  await doFetch(set, newSearchForm)
}

export const pageSizeChangeCallback = ({ snapshot, set }) => async pageSize => {
  const searchForm = await snapshot.getPromise(searchState)
  const newSearchForm = { ...searchForm, pageSize, pageNumber: 1 }

  await doFetch(set, newSearchForm)
}

export const headerClickCallback = ({ snapshot, set }) => async fieldName => {
  const searchForm = await snapshot.getPromise(searchState)
  const newSearchForm = {
    ...searchForm,
    orderBy: fieldName,
    orderDesc: !searchForm.orderDesc,
    pageNumber: 1
  }

  await doFetch(set, newSearchForm)
}

export const deliverabilityIndexCallback = ({ set }) => async () => {
  set(deliverabilityIndexState, prev => ({
    ...prev,
    loaded: false,
    loading: true
  }))

  try {
    const deliverabilityIndex = await getDeliverabilityIndex()
    set(deliverabilityIndexState, deliverabilityIndex)
  } catch (error) {
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    logAppError({
      Component: 'Smpt+ list',
      Method: 'deliverabilityIndexCallback',
      appError: error
    })
  }
  set(deliverabilityIndexState, prev => ({
    ...prev,
    loaded: true,
    loading: false
  }))
}
